<div *ngIf="registration != undefined"
      (click)="showList = false; $event.stopPropagation();"
      class="listContainer">
      <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
    <div class="list-title">
        <span class="title">
            {{ 'reg.involved_unit' | translate }}
        </span>
    </div>
    <div class="row p-0 m-0 page-table expanded-list">
        <div class="list-group-collapse duo flex-wrap list-item-container" *ngIf="institutionUnits?.length">
            <div class="{{ disabled ? 'list-item-disabled' : 'list-item' }} duo first item">
                <div *ngFor="let regUnit of registrationUnits" class="d-flex justify-content-between col">
                    <div class="d-flex align-items-center w-100 {{ disabled ? '' : 'cursor-pointer' }}"
                         (click)="openEdit(regUnit);$event.stopPropagation();">
                        {{regUnit.name}}
                    </div>
                    <div class="d-flex align-items-center" *ngIf="!disabled">
                        <confirmation [showTrashIcon]="true"
                                      [question]="'confirm.areyousure'"
                                      [extraClasses]="'d-flex'"
                                      (isConfirmed)="deleteRegistrationUnit($event, regUnit.id)"></confirmation>
                    </div>
                </div>
            </div>
        </div>
        <drawer-items class="mt-1"
            [items]="institutionUnits"
            [title]="'reg.involved_unit'"
            (itemSelected)="addRegistrationUnit($event)"
            [openListButtonLabel]="'Select or add new'"
            [showAddButton]="true"
            (askForNew)="openEdit(false, $event)"></drawer-items>
    </div>
</div>
